// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__fB1if","footerItems":"Footer_footerItems__wL_ga"};